// Chart widgets get a `color` from the API's `gui.color` field (see useChartsStore.js).
// Those colors are drawn from a large, randomly-ordered palette, which is fine for the
// default look, but a white-label skin may want every widget drawn from its own brand
// palette instead. A skin opts in by setting `colors.useChartBrandColors: true` plus
// `colors.chartBrandColors` (and optionally `colors.knownChartColorMap`) in its
// public/skins/<name>/init.js; any API color not pinned in that map falls back to a
// deterministic hash so it still lands on a brand color and stays stable across renders.
// Skins that leave useChartBrandColors unset/false get the API color unchanged, so this
// is a no-op for the default look — a skin can keep chartBrandColors defined (e.g. for
// mockups or a future client) without it taking effect until useChartBrandColors is on.

function hashColor(color, brandColors) {
  let hash = 0;
  for (let i = 0; i < color.length; i++) {
    hash = (hash * 31 + color.charCodeAt(i)) | 0;
  }
  return Math.abs(hash) % brandColors.length;
}

export function getBrandColor(color) {
  if (!color) return color;
  const colors = window.skin?.colors;
  if (!colors?.useChartBrandColors) return color;

  const brandColors = colors.chartBrandColors;
  if (!brandColors?.length) return color;

  const knownColorMap = colors.knownChartColorMap || {};
  const key = color.toLowerCase();
  return knownColorMap[key] || brandColors[hashColor(key, brandColors)];
}
